import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input'
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { DragDropModule } from '@angular/cdk/drag-drop'; 
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

import { OpenOrdersCardComponent } from './cards/open-orders-card/open-orders-card.component';
import { UserDashboardComponent } from './user-dashboard/user-dashboard.component';
import { ThisoverlastCardComponent } from './cards/thisoverlast-card/thisoverlast-card.component';
import { NeedsBinCardComponent } from './cards/needs-bin-card/needs-bin-card.component';
import { NegativeItemsCardComponent } from './cards/negative-items-card/negative-items-card.component';
import { GapReportCardComponent } from './cards/gap-report-card/gap-report-card.component';
import { NoPurchasesCardComponent } from './cards/no-purchases-card/no-purchases-card.component';
import { TelegramReportsCardComponent } from './cards/telegram-reports-card/telegram-reports-card.component';
import { BrandReportCardComponent } from './cards/brand-report-card/brand-report-card.component';
import { ProductlineSalesReportCardComponent } from './cards/productline-sales-report-card/productline-sales-report-card.component';
import { CategorySalesReportCardComponent } from './cards/category-sales-report-card/category-sales-report-card.component';
import { CustomertypeSalesReportCardComponent } from './cards/customertype-sales-report-card/customertype-sales-report-card.component';
import { RecentTransactionsCardComponent } from './cards/recent-transactions-card/recent-transactions-card.component';
import { ItemsSoldCardComponent } from './cards/items-sold-card/items-sold-card.component';
import { OpenQuotesCardComponent } from './cards/open-quotes-card/open-quotes-card.component';
import { ItemsReceivedCardComponent } from './cards/items-received-card/items-received-card.component';
import { UserDashboardEditorComponent } from './user-dashboard-editor/user-dashboard-editor.component';
import { BlankCardComponent } from './cards/blank-card/blank-card.component';



@NgModule({
	declarations: [
		OpenOrdersCardComponent,
		UserDashboardComponent,
		ThisoverlastCardComponent,
		NeedsBinCardComponent,
		NegativeItemsCardComponent,
		GapReportCardComponent,
		NoPurchasesCardComponent,
		TelegramReportsCardComponent,
		BrandReportCardComponent,
		ProductlineSalesReportCardComponent,
		CategorySalesReportCardComponent,
		CustomertypeSalesReportCardComponent,
		RecentTransactionsCardComponent,
		ItemsSoldCardComponent,
		OpenQuotesCardComponent,
		ItemsReceivedCardComponent,
		UserDashboardEditorComponent,
		BlankCardComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		MatTooltipModule,
		MatButtonModule,
		MatInputModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatRadioModule,
		DragDropModule,
		MatSlideToggleModule,
		MatAutocompleteModule
	],
	exports:[
		OpenOrdersCardComponent,
		UserDashboardComponent,
		ThisoverlastCardComponent,
		NeedsBinCardComponent,
		NegativeItemsCardComponent,
		GapReportCardComponent,
		NoPurchasesCardComponent,
		TelegramReportsCardComponent,
		BrandReportCardComponent,
		ProductlineSalesReportCardComponent,
		CategorySalesReportCardComponent,
		CustomertypeSalesReportCardComponent,
		RecentTransactionsCardComponent,
		ItemsSoldCardComponent,
		OpenQuotesCardComponent,
		ItemsReceivedCardComponent,
		UserDashboardEditorComponent,
		BlankCardComponent
	]
})
export class DynamicDashboardModule { }
